const fonts = {
  header: "Raleway Variable, sans-serif",
  text: "Open Sans, sans-serif",
};

export default fonts;
